import React, { useState, useEffect } from 'react';
import '../styles/Recorder.css';
import MicRecorder from 'mic-recorder-to-mp3';
import {
  RiMicLine,
  RiRecordCircleLine,
  RiStopCircleLine,
} from 'react-icons/ri';

const RecorderComponent = ({ isRecording, setIsRecording }) => {
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [showAudio, setShowAudio] = useState(false);
  const [mp3Recorder, setMp3Recorder] = useState(null);

  const start = async () => {
    if (isBlocked) {
    } else {
      const recorder = new MicRecorder({ bitRate: 128 });
      setMp3Recorder(recorder);
      try {
        await recorder.start();
        setIsRecording(true);
        setShowAudio(false);
        localStorage.setItem('audioRecording', 'true');
      } catch (error) {
        console.error(error);
      }
    }
  };

  const stop = async () => {
    try {
      await mp3Recorder.stop();
      const [buffer, blob] = await mp3Recorder.getMp3();
      const blobURL = URL.createObjectURL(blob);
      setBlobURL(blobURL);
      setIsRecording(false);
      setShowAudio(true);
      localStorage.setItem('audioBlobURL', blobURL);
      localStorage.removeItem('audioRecording');
    } catch (error) {
      console.error(error);
    }
  };

  const recordAgain = () => {
    setShowAudio(false);
    setBlobURL('');
    localStorage.removeItem('audioBlobURL');
    localStorage.removeItem('audioRecording');
  };

  useEffect(() => {
    const savedAudioBlobURL = localStorage.getItem('audioBlobURL');
    const isRecording = localStorage.getItem('audioRecording');
    if (savedAudioBlobURL) {
      setBlobURL(savedAudioBlobURL);
      setShowAudio(true);
    }
    if (isRecording) {
      setIsRecording(true);
    }

    navigator.getUserMedia(
      { audio: true },
      () => {
        setIsBlocked(false);
      },
      () => {
        setIsBlocked(true);
      }
    );

    return () => {
      localStorage.removeItem('audioBlobURL');
      localStorage.removeItem('audioRecording');
    };
  }, []);

  return (
    <div className='recorder-component'>
      {!isRecording && !showAudio ? (
        <button onClick={start} disabled={isBlocked}>
          <RiMicLine className='record' />
        </button>
      ) : null}
      {isRecording ? (
        <div className='recording'>
          <RiRecordCircleLine className='record-symbol' />
          <RiStopCircleLine className='stop' onClick={stop} />
        </div>
      ) : null}
      {showAudio ? (
        <div className='record-result'>
          <audio
            src={blobURL}
            controls='controls'
            className='audio-container'
          />
          <button onClick={recordAgain} className='refresh'>
            Rekam Ulang
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default RecorderComponent;
